import React, { memo } from 'react';

import Locale from '@components/Locale';

import TutorialItem from '../../contents/Tutorial/TutorialItem/TutorialItem';
const TutorialItemRoute = () => (
  <Locale>
    <TutorialItem />
  </Locale>
);

export default memo(TutorialItemRoute);
